/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import AddOrUpdateModel from "../GenericComponents/AddOrUpdateModel";
import ManualCost from "./ManualCost";
import { CostModel } from "../../Utils/Models";
import { updateData } from "../../Services/updateData";
import { urlEnum } from "../../Utils/UrlEnum";
import { postData } from "../../Services/postData";
import { Tab, Tabs } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import ItemList from "./ItemList";

type CustomerMainPageProps = {
  item: any;
  open: boolean;
  onClose: () => void;
  title?: string;
};
export default function ManualCostPage(props: CustomerMainPageProps) {
  const { item, open, onClose, title } = props;
  const ref: any = useRef();
  const [pressOnSubmit, setPressOnSubmit] = useState(false);
  const [manualCost, setManualCost] = useState(new CostModel());
  const [file, setFile] = useState<File | undefined>();
  const [value, setValue] = useState(0);

  function handleChangeValue(event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);
  }

  useEffect(() => {
    if (item) {
      setManualCost(item);
    }
  }, [item]);
  /**
   *
   */
  useEffect(() => {
    if (pressOnSubmit) {
      ref.current.submit();
      //reset the value
      handleChangePressOnSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pressOnSubmit]);

  /**
   *
   */
  function handleChangePressOnSubmit() {
    setPressOnSubmit(!pressOnSubmit);
  }

  function handleSaveOrUpdate(costs: CostModel) {
    const formData = new FormData();
    Object.entries(costs).forEach(([key, value]) => {
      if (key === "customer" || key === "vendor") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });
    if (file) {
      formData.append("file", file);
    }
    if (costs._id) {
      updateData(`${urlEnum.costs}/${costs._id}`, formData)
        .then((res) => {
          if (res) {
            onClose();
          }
        })
        .catch((err) => {
          onClose();
        });
    } else {
      postData(`${urlEnum.costs}`, formData)
        .then((res) => {
          if (res) {
            onClose();
          }
        })
        .catch((err) => {
          onClose();
        });
    }
  }

  function showInformation() {
    switch (value) {
      case 0:
        return (
          <ManualCost
            manualCost={manualCost}
            setManualCost={setManualCost}
            setFile={setFile}
            file={file}
          />
        );
      case 1:
        return <ItemList manualCost={manualCost} setManualCost={setManualCost} items={manualCost.items} />;
      default:
        break;
    }
  }
  
  return (
    <ValidatorForm
      ref={ref}
      onSubmit={() => {
        handleSaveOrUpdate(manualCost);
      }}
    >
      <AddOrUpdateModel
        open={open}
        title={title || ""}
        onClose={onClose}
        isSubmit={true}
        addOrUpdateItem={() => null}
        handleChangePressOnSubmit={handleChangePressOnSubmit}
      >
        <Tabs value={value} onChange={handleChangeValue} textColor="inherit">
          <Tab label={Vocabulary.invoice} />
          <Tab label={Vocabulary.items} />
        </Tabs>
        {showInformation()}
      </AddOrUpdateModel>
    </ValidatorForm>
  );
}
